// src/shared/hooks/useFetch.ts
import { useEffect, useState } from 'react';
import { apiSecure } from '../axios.service';
import { ResponseApi } from '../../types/response/responseapi.model';
import { ResponsePlanning } from '../../types/response/responseplanning.model';
import { DeleteReservationRequest } from '../../types/request/deletereservation.model';
import { ResponsePlanningAdmin } from '../../types/response/responseplanningadmin.model';

export function useReservation<ReservationRequest>(request: ReservationRequest | null | undefined) {
  const [data, setData] = useState<ResponseApi | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
      if (request) {
      setIsLoading(true);
      apiSecure.post<ReservationRequest>("/reservation", request)
          .then(res => setData(res.data as ResponseApi))
          .catch(err => setError(err))
          .finally(() => setIsLoading(false));
      }
  }, [request]);

  return {data, isLoading, error };
}

export function useGetReservations(){
  const [data, setData] = useState<ResponsePlanning[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
      setIsLoading(true);
      apiSecure.get<ResponsePlanning[]>("/allreservations")
          .then(res => setData(res.data as ResponsePlanning[]))
          .catch(err => setError(err))
          .finally(() => setIsLoading(false));
  }, []);

  return {data, isLoading, error };
}


export function useGetReservationsAdminGarde(){
  const [data, setData] = useState<ResponsePlanningAdmin[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
      setIsLoading(true);
      apiSecure.get<ResponsePlanningAdmin[]>("/garde/allreservations")
          .then(res => setData(res.data as ResponsePlanningAdmin[]))
          .catch(err => setError(err))
          .finally(() => setIsLoading(false));
  }, []);

  return {data, isLoading, error };
}

export function useGetUserReservations(){
  const [data, setData] = useState<ResponsePlanning[] | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
      setIsLoading(true);
      apiSecure.post<ResponsePlanning[]>("/getuserreservations", {username: localStorage.getItem("username")})
          .then(res => setData(res.data as ResponsePlanning[]))
          .catch(err => setError(err))
          .finally(() => setIsLoading(false));
  }, []);

  return {data, isLoading, error };
}

export function useDeleteReservation(request: DeleteReservationRequest | null | undefined){
  const [dataDel, setData] = useState<ResponseApi | null>(null);
  const [isLoadingDel, setIsLoading] = useState(false);
  const [errorDel, setError] = useState<any>(null);

  useEffect(() => {
    if(request){
      setIsLoading(true);
      apiSecure.post<ResponsePlanning[]>("/deletereservation", request)
          .then(res => setData(res.data as ResponseApi))
          .catch(err => setError(err))
          .finally(() => setIsLoading(false));
    }
  }, [request]);

  return {dataDel, isLoadingDel, errorDel };
}

export function useAdminReservation<ReservationAdminRequest>(request: ReservationAdminRequest | null) {
  const [data, setData] = useState<ResponseApi | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
      if (request) {
      setIsLoading(true);
      apiSecure.post<ReservationAdminRequest>("/admin/reservation", request)
          .then(res => setData(res.data as ResponseApi))
          .catch(err => setError(err))
          .finally(() => setIsLoading(false));
      }
  }, [request]);

  return {data, isLoading, error };
}